import { gql } from "@apollo/client";

export const GET_SUB_CATEGORIES = gql`
  query SubCategories($where: SubCategoryWhereInput, $orderBy: OrderByInput, $limit: Int) {
    subCategories(where: $where, orderBy: $orderBy, limit: $limit) {
      total
      data {
        id
        name
        category {
          id
          name
        }
      }
    }
  }
`;

export const CREATE_SUB_CATEGORY = gql`
  mutation CreateSubCategory($data: SubCategoryInput!) {
    createSubCategory(data: $data) {
      id
      name
    }
  }
`;
